import { useCallback, useContext } from 'react';



import { UserContext } from '@/app/UserProvider';
import { logout as logoutApi } from '@/services/authService';
import { removeAuthToken } from '@/shared/lib/client';

export const useAuth = () => {
  const { user, setUser, hasToken, isLoading } = useContext(UserContext);

  // 登出
  const logout = async () => {
    try {
      await logoutApi();
    } catch (error) {
      console.error('Logout API failed:', error);
    } finally {
      // 无论API调用是否成功，都清除本地状态和cookie
      setUser(null);
      removeAuthToken();
      // 跳转到登录页面
      window.location.href = '/login';
    }
  };

  // 刷新用户信息（从 UserProvider 的角度，这个功能需要在 UserProvider 中实现）
  const refreshUser = useCallback(() => {
    // 由于用户信息由 UserProvider 管理，这里可以触发页面刷新或者在 UserProvider 中暴露刷新方法
    window.location.reload();
  }, []);

  return {
    user,
    loading: isLoading,
    error: null,
    logout,
    refreshUser,
    isAuthenticated: !!user && hasToken,
  };
};